import {createAction, props} from '@ngrx/store';
import {Toggles} from './toggles';

export enum TogglesActionTypes {
  AKTUALIZUJ = '[Toggles] aktualizuj',
}

export const aktualizuToggle = createAction(
  TogglesActionTypes.AKTUALIZUJ, props<{ toggles: Toggles }>()
);
